
define('text!modules/targeting/video/templates/bin_item.html',[],function () { return '<div class="column segment">\n    <div class="item-c text" data-dimension="{{dimension_code}}" data-id="{{id}}"><span class="strong">{{{item}}}</span></div>\n</div>';});

